import { inject } from '@angular/core';

import { Store } from '@ngrx/store';
import { take } from 'rxjs';

import { filterDefined } from '@core/common-legacy';

import { CountrySelectors } from './store/country.store';
import type { Country, CountryMap } from './types';

export const injectCountryList = () => {
  let countryList: Country[] = [];
  inject(Store)
    .select(CountrySelectors.asList)
    .pipe(filterDefined, take(1))
    .subscribe(data => {
      countryList = data;
    });
  return countryList;
};

export const injectCountryMap = () => {
  let countyMap: CountryMap = {};
  inject(Store)
    .select(CountrySelectors.asMap)
    .pipe(filterDefined, take(1))
    .subscribe(data => {
      countyMap = data;
    });
  return countyMap;
};
